import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { XTabNav } from '@/components/xqxc_ui';
import CancelOrderList from './cancelorder';
import { TabType } from './types';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const tabList = [
    { id: TabType.CancelOrder, label: '取消订单' }
];

const Detail = (props) => {

    const [curTabID, setCurTabID] = useState(TabType.CancelOrder);

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            {curTabID === TabType.CancelOrder && <CancelOrderList curTabID={curTabID} {...props} />}
        </div>
    );
};

Detail.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Detail);